import { render, staticRenderFns } from "./RekapBencanaInput.vue?vue&type=template&id=2afd0f50&scoped=true"
import script from "./RekapBencanaInput.vue?vue&type=script&lang=js"
export * from "./RekapBencanaInput.vue?vue&type=script&lang=js"
import style0 from "./RekapBencanaInput.vue?vue&type=style&index=0&id=2afd0f50&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2afd0f50",
  null
  
)

export default component.exports